"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _core = require("@material-ui/core");
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
var badgeProps = {
  'non-member': {
    label: 'Non-Member',
    class: 'nonmember'
  },
  member: {
    label: 'Member',
    class: 'member'
  },
  admin: {
    label: 'Admin',
    class: 'admin'
  },
  inactive: {
    label: 'Inactive',
    class: 'inactive'
  },
  active: {
    label: 'Active',
    class: 'active'
  }
};
var getBadges = function getBadges(badgeData, classes) {
  var badges;
  var badgeComp = [];
  if (!badgeData || Array.isArray(badgeData) && !badgeData.length) {
    badges = [badgeProps.default];
  } else {
    badges = badgeData.map(function (badge) {
      return badgeProps[badge];
    });
  }
  badges.forEach(function (element) {
    if (element) {
      var classValue = "".concat(classes.badge, " ").concat(classes[element.class]);
      badgeComp.push( /*#__PURE__*/_react.default.createElement(_core.Chip, {
        className: classValue,
        label: element.label
      }));
    }
  });
  return badgeComp;
};
var processRoleData = function processRoleData(data) {
  return [data.role, data.userStatus];
};
function RoleBadgeGroup(_ref) {
  var data = _ref.data,
    classes = _ref.classes;
  var roleData = processRoleData(data);
  var badgeInfo = getBadges(roleData, classes);
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("div", {
    className: classes.badgeGroup
  }, badgeInfo));
}
var styles = function styles() {
  return {
    badgeGroup: {
      display: 'flex',
      flexDirection: 'row',
      boxSizing: 'border-box',
      margin: '10px'
    },
    badge: {
      borderRadius: '5px',
      height: '20px',
      border: '1px solid #a0a2b1',
      margin: '0 5px'
    },
    inactive: {
      backgroundColor: '#ebc0bc',
      color: '#4f5d69'
    },
    active: {
      backgroundColor: '#9adcc9',
      color: '#4f5d69'
    },
    admin: {
      backgroundColor: '#d8d3e9',
      color: '#4f5d69'
    },
    member: {
      backgroundColor: '#d3e4f5',
      color: '#4f5d69'
    },
    nonmember: {
      backgroundColor: '#dcdee0',
      color: '#4f5d69'
    },
    default: {
      color: '#4f5d69'
    }
  };
};
var _default = (0, _core.withStyles)(styles, {
  withTheme: true
})(RoleBadgeGroup);
exports.default = _default;